<script setup lang="ts">
import GeneralLayout from '@/layout/GeneralLayout.vue';
import sadFace from '@/assets/icons/face-sad-cry-regular.svg';
</script>

<template>
  <GeneralLayout>
    <div class="my-12 flex flex-col px-4" data-test="screen-notfound">
      <img :src="sadFace" class="mb-3 size-16" />
      <h1 class="mb-4 text-3xl">Whoops! Page Not Found</h1>
      <p class="mb-8">
        It seems we've hit a dead end – the page you're looking for has mysteriously vanished or
        never existed. But don't worry, adventure continues, simply go back to the previous page you
        were on and try again.
      </p>
    </div>
  </GeneralLayout>
</template>

<style scoped></style>
